import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import Swal from 'sweetalert2';
import { Responsables, obtenerTamMax, alertas, obtenerError, procesamiento } from '../../../models/Formulacion/indicadores-metas/datos';
import { AltaactasService } from '../../../services/formulacion/altaactas/altaactas.service';
import { FiltersM } from '../../../components/models';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { PlanesService } from '../../../services/gestion/planes/planes.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-alta-actas',
  templateUrl: './alta-actas.component.html',
  styleUrl: './alta-actas.component.css'
})
export class AltaActasComponent {
  public readonly permisos = PERMISOS;
  
  public Filters = FiltersM;
  public idPlanificacion :any;
/* Variables de los filtros */
  public aniosDisponibles = [];
  public responsables: Responsables[] =[];
  public responsablesActas: Responsables[] = [];
  public responsablesActividadesActas: Responsables[] = [];
  public selecAllResActas = true;
  public selecAllResActiv = true;

  /* Variables de funcionamiento de tablas */
  public mostabla = false;
  public skeleton = new Array(15);
  public skeletonColums = new Array(6);
  public meses = [];
  public mostrarAllActas = false;
  public adicionales = [];
  public  ordenamiento = 'id';

  /* Variables de datos tablas */
  public actas = [];
  public actasMostrar = [];
  public actividadesActas = [];

  /* Variables para el formateo de cantidades */
  public separador:string =  ","; // separador para los miles
  public sepDecimal:string = '.'; // separador para los decimales

  /* Variables para los datePiker */
  public myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };
  public minDate: any;
  public maxDate: any;
  public fechaAct;
  public maxAdi = [];

  /* Variables de agregado de información */
  public edicionActa: any;
  private actaId: any;
  public edicionActividad: any;
  public nombreArchivo = '';
  public editarArch = false;
  private totalAct = 0;
  public accionActa = ''; // nuevo -- editar
  public accionActi = ''; // nuevo -- editar
  public diasLab = '';
  public titModal = '';

  modal1 = false;
  modal2 = false;
  modal3 = false;

  /** Grupo de validación de datos */
  formActas = new FormGroup({ 
    inputNameActa: new FormControl('', [Validators.required]),
    inputDescripcion: new FormControl(''),
    inputLider: new FormControl('', [Validators.required]),    
    inputArchivo: new FormControl(''),    
  }, { validators: this.nombreDuplicidad()});
  formActividad = new FormGroup({ 
    inputNameAct: new FormControl('', [Validators.required]),
    inputFechaIn: new FormControl('', [Validators.required]),
    inputFechaFn: new FormControl('', [Validators.required]),
    inputLider: new FormControl('', [Validators.required]),
  });
  formAdicional = new FormGroup({ 
    inputName: new FormControl('', [Validators.required]),
    inputType: new FormControl('', [Validators.required]),
  },{ validators: this.nombreDuplicidadAdi() });

  constructor(
    public dataService: DataService,
    private cookieService: CookieService,
    private excelService: ExcelService,
    // private altaActasService: AltaactasService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private altaActasService: PlanesService,
  ) { 
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
    this.idPlanificacion = Number(cookieService.get('idInstitucion'));
    this.obtenerDatos();
  }
  ngOnInit(){
    this.fechaAct = moment().format("YYYY-MM-DD");
  }

  /* Consultas de inicio */
  private async obtenerDatos(){
    try{
      this.idPlanificacion = Number(this.cookieService.get('idInstitucion'));
      const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion)
      await this.obtenerFiltros(plan);
      
      const res2 = await this.altaActasService.getActasGql(this.idPlanificacion);
      this.obtenerActas(res2);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  private async obtenerActasNuevamente(texto){
    try{
      this.close_modal();
      this.actas = this.ordenamientoPer(this.actas);
    
      this.obtenerfechasActas();
      if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length !== 0 ){
        this.adicionales = this.actas[0].actividades[0].adicionales;
      }else if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length === 0 ){
        this.adicionales = [];
      }
      this.dataTablaMostrar('cam');
      this.obtResponsableDinamico();
      this.mostabla = true;
      messages.succesMessageGraph(texto);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  private async obtenerActividadesNuevamente(texto){
    try{
      this.obtenerfechasActas();
      this.dataTablaMostrar('cam');
      this.obtResponsableDinamico();
      this.mostabla = true;

      messages.succesMessageGraph(texto);
      this.close_modal();
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* Extracción de datos */
  // Filtros
  private async obtenerFiltros(plan: any){    
    if(plan.length !== 0){
      const planeacion = plan;
      const fechIni = moment(planeacion.initial_date.split('T')[0]);
      const fechFin = moment(planeacion.end_date.split('T')[0]);
      const fechAct = moment().format("YYYY-MM-DD");

      try{
        const res = await firstValueFrom(this.responsableService.getResponsable()); 
        this.responsables = [];
          var aux = [];
          for(const are of res){
            if(are.institution.id === planeacion.institution.id){
              for(const res of are.responsibles){
                aux.push({
                  nombre: res.position,
                  id: res.id,
                  check: true,
                  isValidator: res.isValidator,
                });
              }
            }
          }
          this.responsables = this.ordenamientoAlf(aux);
      }catch(err){
        messages.errorMessageGraph(err);
      }

      this.diasLab = planeacion.business_days;
      const filters = {
        'Lunes-Viernes': (d: Date | null): boolean => {
          const day = (d || new Date()).getDay();
          return day !== 0 && day !== 6;
        },
        'Lunes-Sabado': (d: Date | null): boolean => {
          const day = (d || new Date()).getDay();
          return day !== 0;
        },
        'Lunes-Domingo': (): boolean => true,
      };
      
      this.myFilter = filters[plan.business_days] || (() => true);
      this.aniosDisponibles = [];
      while(fechIni.isSameOrBefore(fechFin, 'year')){
        this.aniosDisponibles.push({
          name: fechIni.format("YYYY"),
          check: false,
        });
        fechIni.add(1, 'years');
      }
      const today = moment().format('YYYY');
      const ex = this.aniosDisponibles.find(an => an.name === today);
      if(ex){
        ex.check = true;
      }else{
        this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
        this.setYear(this.aniosDisponibles[this.aniosDisponibles.length-1].name)
        this.meses = this.getMesesConDias(this.aniosDisponibles[this.aniosDisponibles.length-1].name);
      }
      this.minDate =  moment(planeacion.initial_date.split('T')[0]);
      this.maxDate = fechFin.format('YYYY-MM-DD');
    }
  }
  // Actas
  private obtenerActas(array: any){
    var auxiliar = [];
        for(const acta of array){
          auxiliar.push({
            nombre: acta.name,
            descripcion: acta.description,
            responsable: acta.validator,
            acta: acta.attachment,
            id: acta.id,
            check: true,
            fecha_ini: undefined,
            fecha_fin: undefined,
            actividades: acta.activities.map(acti =>{
              return {
                nombre: acti.name,
                fecha_inicio: moment(acti.initial_date.split('T')[0]),
                fecha_fin: moment(acti.end_date.split('T')[0]),
                projectId: acta.id,
                responsable: acti.responsible,
                id: acti.id,
                adicionales: this.ordenamientoAdi(acti.additions),
                history: acti.history,
              }
            }),
          });
        }
        this.actas = [];
        this.actas = this.actas.concat(auxiliar);
        this.actas = this.ordenamientoPer(this.actas);
        
        this.obtenerfechasActas();
        if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length !== 0 ){
          this.adicionales = this.actas[0].actividades[0].adicionales;
        }else if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length === 0 ){
          this.adicionales = [];
        }
        this.dataTablaMostrar('cam');
        this.obtResponsableDinamico();
        this.mostabla = true;
  }
  //Actividades de las actas
  private obtenerActividadesActas(array){
    for(const actas of this.actas){
      const actividades = array.filter(actaId => actaId.minute.id === actas.id);
      if(actividades.length !== 0){
        var auxiliar = [];
        for(const acti of actividades){
          auxiliar.push({
            nombre: acti.name,
            fecha_inicio: moment(acti.initial_date.split('T')[0]),
            fecha_fin: moment(acti.end_date.split('T')[0]),
            projectId: acti.minute.id,
            responsable: acti.responsible,
            id: acti.id,
            adicionales: this.ordenamientoAdi(acti.additions),
            history: acti.history,
          });
          this.totalAct++;
        }
        actas.actividades = auxiliar;
      }
    }
    this.obtenerfechasActas();
    if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length !== 0 ){
      this.adicionales = this.actas[0].actividades[0].adicionales;
    }
    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();
    this.mostabla = true;
  }  
  //Fechas de proyectos
  public obtenerfechasActas(){
    for(const pro of this.actas){
      pro.fecha_fin = undefined;
      pro.fecha_ini = undefined;
      for(const act of pro.actividades){
        if(pro.fecha_ini === undefined){
          pro.fecha_ini = act.fecha_inicio;
        }else{
          if(pro.fecha_ini.isAfter(act.fecha_inicio)){
            pro.fecha_ini = act.fecha_inicio;
          }
        }
        if(pro.fecha_fin === undefined){
          pro.fecha_fin = act.fecha_fin;
        }else{
          if(pro.fecha_fin.isBefore(act.fecha_fin)){
            pro.fecha_fin = act.fecha_fin;
          }
        }
      }
    }
  }
  /* Obtención de datos a mostrar */
  public dataTablaMostrar(parametros: any){
    var actasTot = [].concat(this.actas);    
    var aux = [];  
    this.maxAdi = [];
    for(const acta of actasTot){
      switch(parametros){
        case 'all':
          if( this.mostrarConResponsables(acta) ){
            var auxAct = [];
            var anioIni, anioFin, anioSelect;
            if(acta.actividades.length !== 0){
              for(const act of acta.actividades){
                anioSelect = moment(this.aniosDisponibles.find(an => an.check)?.name, 'YYYY');
                anioIni = moment(act.fecha_inicio);
                anioFin = moment(act.fecha_fin);
                if(moment(anioSelect).isSameOrBefore(anioFin,'year') && moment(anioSelect).isSameOrAfter(anioIni,'year')){
                  auxAct.push(act);
                  if(this.maxAdi.length < act.adicionales.length){
                    this.maxAdi.push(act.adicionales);
                  }
                }
              }
            }
            aux.push({
              nombre: acta.nombre,
              descripcion: acta.descripcion,
              responsable: acta.responsable,
              acta: acta.acta,
              id: acta.id,
              check: acta.check,
              fecha_ini: acta.fecha_ini,
              fecha_fin: acta.fecha_fin,
              actividades: auxAct,
            });
          }
        break;
        case 'cam':
          if( this.existeAnio(acta) ){
            var auxAct = [];
            var anioIni, anioFin, anioSelect;
            if(acta.actividades.length !== 0){
              for(const act of acta.actividades){
                anioSelect = moment(this.aniosDisponibles.find(an => an.check)?.name, 'YYYY');
                anioIni = moment(act.fecha_inicio);
                anioFin = moment(act.fecha_fin);
                if(moment(anioSelect).isSameOrBefore(anioFin,'year') && moment(anioSelect).isSameOrAfter(anioIni,'year')){
                  auxAct.push(act);
                  if(this.maxAdi.length < act.adicionales.length){
                    this.maxAdi.push(act.adicionales);
                  }
                }
              }
            }
            aux.push({
              nombre: acta.nombre,
              descripcion: acta.descripcion,
              responsable: acta.responsable,
              acta: acta.acta,
              id: acta.id,
              check: acta.check,
              fecha_ini: acta.fecha_ini,
              fecha_fin: acta.fecha_fin,
              actividades: auxAct,
            });
          }
        break;
      }
    }
    if(parametros === 'all' && !this.selecAllResActiv){
      const res = this.responsablesActividadesActas.filter(res => res.check===true);
      if(res.length!==0){
        for(const a of aux){
          const act = a.actividades.filter(act => this.responsableActOfActas(act)===true);
          a.actividades = act;
        }        
      }
    }
    this.actasMostrar = aux;
    this.cdr.detectChanges();
  }
  //Obtención de responsables
  private obtResponsableDinamico(){
    var aux = [], aux2 = [];
    for(const acta of this.actasMostrar){
      const res = this.responsables.filter(res => res.id === acta.responsable.id);
      const existe = aux.filter(res => res.id === acta.responsable.id);
      if(existe.length === 0){
        aux.push({
          nombre: res[0].nombre,
          name: res[0].nombre,
          id: res[0].id,
          check: true,
        });
      }
      for(const resp of acta.actividades){
        const resAct = this.responsables.filter(res => res.id === resp.responsable.id);
        const existeAct = aux2.filter(res => res.id === resp.responsable.id);
        if(existeAct.length === 0){
          aux2.push({
            nombre: resAct[0].nombre,
            name: res[0].nombre,
            id: resAct[0].id,
            check: true,
          });
        }
      }
    }
    this.responsablesActas = this.ordenamientoAlf(aux);
    this.selecAllResActas = true;
    this.responsablesActividadesActas = this.ordenamientoAlf(aux2);
    this.selecAllResActiv = true;
  }

  //Mostrar considerando los responsables
  public mostrarConResponsables(acta: any){
    if( this.responsableActas(acta) && this.existeAnio(acta) ){
      return true;
    }else{
      return false;
    }
  }
  //Metodos de decición
  private existeAnio(acta: any){
    if(acta.fecha_ini !== undefined && acta.fecha_ini !== undefined){
      var fecha_ini = Number(moment(acta.fecha_ini).format('YYYY')), fecha_fin = Number(moment(acta.fecha_fin).format('YYYY'));
      for(const an of this.aniosDisponibles){
        if(an.check === true && (Number(an.name) >= fecha_ini && Number(an.name) <= fecha_fin) ){
          return true;
        }
      }
      return false;
    }else{
      return true;
    }
  }
  private responsableActas(acta: any){
    for(const res of this.responsablesActas){
      if(res.id === acta.responsable.id && res.check){
        return true;
      }
    }
    return false;
  }
  public responsableActOfActas(act: any){
    for(const res of this.responsablesActividadesActas){
      if(res.id === act.responsable.id && res.check){
        return true;
      }
    }
    return false;
  }
  /* Eventos de tablas */
  public mostrarTodasLasActas(){
    this.actasMostrar.forEach(acta => this.mostrarAllActas?acta.check=false:acta.check=true)
    this.mostrarAllActas = !this.mostrarAllActas;
  }
  public mostrarActas(acta: any){
    acta.check = !acta.check;
    var actasAbiertas = 0;
    for(const actas of this.actasMostrar){
      if(actas.check){
        actasAbiertas++;
      }
    }
    if(actasAbiertas === this.actasMostrar.length){
      this.mostrarAllActas = true;
    }else if(actasAbiertas === 0){
      this.mostrarAllActas = false;
    }
  }
  /* Metodos de escritura en tabla */
  public obtComment(com : any){
    for(const comen of com){
      var per =  this.aniosDisponibles.filter(an => an.check)[0].name;
      var percom = moment(comen.created_at).format('YYYY');
      if(per === percom){
        return comen.comment;
      }
    }
    return '';
  }
  //Decición de edición de los adicionales
  public edicionPro(actas: any, adicionalId: any){
    if(actas.actividades.length !== 0){
      for(const act of actas.actividades){
        if(act.adicionales[adicionalId].type === 'moneda'){
          return true;
        }
      }
    }
    return false;    
  }
  //Mostrar los adicionales
  public imprimirPro(acta: any, adicionalId: any){
    var tot = 0;
    var tipo = '';
    for(const act of acta.actividades){
      switch(act.adicionales[adicionalId].type){
        case 'moneda':
          tipo = act.adicionales[adicionalId].type;
          tot += Number(act.adicionales[adicionalId].amount)
        break;
      }
    }
    if(tipo === 'moneda'){
      return this.formatearnormal(tot);
    }
    return ''
  }
  /** Obtención de los datos */
  //Obtención de fechas
  public obtFecha(fec: any){
    if(fec !== undefined){
      return fec.format('DD-MM-YYYY')
    }else{
      return '';
    }
  }
  //Obtención de los dias
  public obtDias(ini: any, fin: any){
    if(ini != undefined && fin != undefined){
      if( (fin - ini) === 0){
        return 1;
      }
      var dias = (fin-ini)/(1000*60*60*24);
      var semanas = Math.trunc(dias/7);
      dias = dias - (semanas*2);
      return Math.round(dias)
    }
    return '';
  }
  //Metodos del gantt
  public pintarGantAct(act: any, dia:any, mes: any){
    var an = '';
    for(const anio of this.aniosDisponibles){
      if(anio.check){
        an = anio.name;
      }
    }
    var fecha = moment((mes+1)+'-'+((dia*2)-1)+'-'+an);
    if((mes+1) === 2 && dia === 15){
      fecha = moment((mes+1)+'-'+((14*2)-1)+'-'+an);
    }
    if(fecha <= act.fecha_fin && fecha>=act.fecha_inicio){
      if(dia === 15)
        return 'w3-orange-gantt w3-rest'
      return 'w3-orange-gantt w3-31'
    }
    if(dia === 15)
      return 'w3-white w3-rest'
    return 'w3-white w3-31'
  }
  public pintarGantPro(act: any, dia:any, mes: any){
    var an = '';
    for(const anio of this.aniosDisponibles){
      if(anio.check){
        an = anio.name;
      }
    }
    var fecha = moment((mes+1)+'-'+((dia*2)-1)+'-'+an);
    if((mes+1) === 2 && dia === 15){
      fecha = moment((mes+1)+'-'+((14*2)-1)+'-'+an);
    }
    if(fecha <= act.fecha_fin && fecha>=act.fecha_ini){
      if(dia === 15){
        return 'w3-black-blue w3-rest';
      }
      return 'w3-black-blue w3-31';
    }
    if(dia === 15){
      return 'w3-white w3-rest';
    }
    return 'w3-white w3-31';
  }
  /* Funcionamiento de los filtros */
  //Filtro de años
  public cambioAnio(an: any){
    for(const anio of this.aniosDisponibles){
      an.name === anio.name? anio.check=true:anio.check=false;
      an.name === anio.name? this.setYear(anio.name):'';
      an.name === anio.name? this.meses = this.getMesesConDias(anio.name):'';
    }
    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();
  }
  //Filtro de lider actas
  public cambioLider(res){
    if(res !== 'consolidado'){
      this.responsablesActas.forEach(ress =>{ ress.nombre === res.nombre? ress.check = !ress.check: ress.check = ress.check});
      var all = 0;
      this.responsablesActas.forEach(ress =>{ ress.check? all++ : all = all });
      if(all === this.responsablesActas.length){
        this.selecAllResActas = true
      }else{
        this.selecAllResActas = false;
      }
    }else{
      if(this.selecAllResActas){
        this.responsablesActas.forEach(ress =>{ ress.check = false});
      }else{
        this.responsablesActas.forEach(ress =>{ ress.check = true});
      }
      this.selecAllResActas = !this.selecAllResActas
      
    }
    if( res !== 'consolidado' || this.selecAllResActas){
      this.dataTablaMostrar('all');
    }
  }
  public selecAllLideres(){
    this.responsablesActas.forEach(res => this.selecAllResActas?res.check=false:res.check=true);
    this.selecAllResActas = !this.selecAllResActas;
    if(this.selecAllResActas){
      this.dataTablaMostrar('all');
    }
  }
  //Filtro de responsable actividades
  public cambioResponsable(res){
    if(res !== 'consolidado'){
      this.responsablesActividadesActas.forEach(ress =>{ ress.nombre === res.nombre? ress.check = !ress.check: ress.check = ress.check});
      var all = 0;
      this.responsablesActividadesActas.forEach(ress =>{ ress.check? all++ : all = all });
      if(all === this.responsablesActividadesActas.length){
        this.selecAllResActiv = true
      }else{
        this.selecAllResActiv = false;
      }
    }else{
      if(this.selecAllResActiv){
        this.responsablesActividadesActas.forEach(ress =>{ ress.check = false});
      }else{
        this.responsablesActividadesActas.forEach(ress =>{ ress.check = true});
      }
      this.selecAllResActiv = !this.selecAllResActiv
      
    }
    if( res !== undefined || this.selecAllResActiv){
      this.dataTablaMostrar('all');
    }
  }
  public selecAllResponsables(){
    this.responsablesActividadesActas.forEach(res => this.selecAllResActiv?res.check=false:res.check=true);
    this.selecAllResActiv = !this.selecAllResActiv;
    if(this.selecAllResActiv){
      this.dataTablaMostrar('all');
    }
  }
  //Vision de los tres puntos
  public tresPuntosVis(){
    var sel = 0;
    for(const res of this.responsablesActas){
      if(res.check){
        sel++;
      }
    }
    if(sel <= 1)
      return false;
    return true;
  }
  public tresPuntosVisResp(){
    var sel = 0;
    for(const res of this.responsablesActividadesActas){
      if(res.check){
        sel++;
      }
    }
    if(sel <= 1)
      return false;
    return true;
  }
  /** Borrar filtros */
  public borrarFiltro(){
    document.body.style.cursor = 'wait';

    const date = new Date();
    this.aniosDisponibles.forEach(an => { moment(this.fechaAct).format('YYYY') == an.name? an.check = true:an.check = false });
    
    this.responsablesActas.forEach(res => res.check = true);
    this.responsablesActividadesActas.forEach(res => res.check = true);

    this.ordenamiento = 'id';

    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();

    setTimeout(() => {
      document.body.style.cursor = 'default';        
    }, 2000 );
  }
  /** Ordenamiento */
  public ordenamientoTabla(){
    switch(this.ordenamiento){
      case 'id':
        this.actasMostrar = this.ordenamientoAlf(this.actasMostrar);
        this.ordenamiento = 'asc';
      break;
      case 'asc':
        this.actasMostrar = this.ordenamientoAlfInv(this.actasMostrar);
        this.ordenamiento = 'des';
      break;
      case 'des':
        this.actasMostrar = this.ordenamientoPer(this.actasMostrar);
        this.ordenamiento = 'id';
      break;
    }
  }
  /* Envio de actas */
  public async envioActa(acta: any){
    var responsibleIds = [], responsibleIdsValidador = [];
    responsibleIdsValidador.push(Number(acta.responsable.id));
    for(const activ of acta.actividades){
      const existe = responsibleIds.filter(id => Number(id) === Number(activ.responsable.id));
      const existeEnValidador = responsibleIdsValidador.filter(id => Number(id) === Number(activ.responsable.id));
      if(existe.length === 0 && existeEnValidador.length === 0){
        responsibleIds.push(Number(activ.responsable.id));
      }
    }
    try{
      const res = await firstValueFrom(this.altaActasService.envioActas(responsibleIds, acta.id)); 
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.alta-actas.actaEnv'));
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* /////////////////////////////////// */
  /* Metodos de los Modales */
  private archivoSeleccionado;
  onFileChange(event){
    const file = event.target.files?.[0];

    if (!file) return;

    this.archivoSeleccionado = (file);
    this.nombreArchivo = file.name;
  }
  /* actas nuevas */
  public modalActas(accion, acta?){
    this.accionActa = accion;
    if(accion === "nuevo"){
      this.titModal = this.translate.instant('gestion.formulacion.alta-actas.titModalActa');
    }else{// se modifica un registro existente
      this.titModal = this.translate.instant('gestion.formulacion.alta-actas.titModalActaEdit');
      this.edicionActa = acta;
      var desc = this.edicionActa.descripcion !== 'null' ? this.edicionActa.descripcion : '';
      this.formActas.controls['inputNameActa'].setValue(this.edicionActa.nombre);
      this.formActas.controls['inputDescripcion'].setValue(desc);
      this.formActas.controls['inputLider'].setValue(this.edicionActa.responsable.id);
      if(this.edicionActa.acta !== null){
        this.editarArch = true;
        this.nombreArchivo = this.edicionActa.acta.split('-')[this.edicionActa.acta.split('-').length-1];
      }
    }
    this.modal1 = true;
    // document.getElementById('modalActa')['style'].display = 'block';
  }
  public async guardarActa(){
    let nombre = this.formActas.controls['inputNameActa'].value;
    let descripcion = this.formActas.controls['inputDescripcion'].value;
    let responsableId = this.formActas.controls['inputLider'].value;
    let documento = this.archivoSeleccionado;

    if( documento !== undefined && documento["size"] > obtenerTamMax.getPeso() ){
      messages.errorMessageGraph(obtenerTamMax.getTexto());
      return;
    }
    var acta;
    if(this.accionActa == 'nuevo'){
      acta = {
        nombre: nombre,
        descripcion: descripcion,
        responsableId: responsableId,
        archivo: documento,
        planId: this.idPlanificacion,
      };
    }else{
      acta = {
        nombre: nombre,
        descripcion: descripcion,
        responsableId: responsableId,
        archivo: documento,
        id: this.edicionActa.id,
        planId: this.idPlanificacion,
      };
    }
    

    messages.messageSaving(this.translate.instant('gestion.formulacion.alta-actas.cargaInfo'),this.translate.instant('swal.espere'));
    if(this.accionActa === 'nuevo'){
      try{
        const res = await firstValueFrom(this.altaActasService.postActas(acta));
        const res2 = await this.altaActasService.getActaByIdGql(res.id);
        this.actas.push({
          nombre: res2.name,
          descripcion: res2.description,
          responsable: res2.validator,
          acta: res2.attachment,
          id: res2.id,
          check: true,
          fecha_ini: undefined,
          fecha_fin: undefined,
          actividades: [],
        });
        Swal.close();
        Swal.close();
        this.obtenerActasNuevamente(this.translate.instant('swal.swalGuardo'));
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }else{
      this.guardarActaEdit(acta)
    }
  }
  public puedeGuardarActas(){
    let nombre = this.formActas.controls['inputNameActa'].value;
    let responsableId = this.formActas.controls['inputLider'].value;

    if(nombre !== '' && responsableId !== '' && !this.nombreExiste()){
      return '';
    }
    return 'w3-disabled';
  }
  public editarArchivoActa(){
    this.editarArch = !this.editarArch;
  }
  public async guardarActaEdit(acta){
   try{
      const actaExist = this.actas.find(act => act.id === acta.id);
      if(actaExist){
        actaExist.nombre = acta.nombre;
        actaExist.descripcion = acta.descripcion;
        actaExist.responsableId = acta.responsableId;
      }
      if(acta.archivo !== undefined && this.editarArch){
        messages.messageSaving(this.translate.instant('gestion.formulacion.alta-planes.cargaArch'),this.translate.instant('swal.espere'));
        const res = await firstValueFrom(this.altaActasService.patchActasfile(acta)); 
        const res2 = await firstValueFrom(this.altaActasService.patchActas(acta));
        Swal.close();
        this.obtenerActasNuevamente(this.translate.instant('swal.swalGuardo'));
      
      }else{
        messages.messageSaving(this.translate.instant('swal.actualizandoInfo'),this.translate.instant('swal.espere'));
        const res = await firstValueFrom(this.altaActasService.patchActas(acta)); 
        Swal.close();
        this.obtenerActasNuevamente(this.translate.instant('swal.swalGuardo'));
      }
      this.editarArch = false;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public puedeGuardarActasEdit(){
    let nombre = this.formActas.controls['inputNameActa'].value;
    let responsableId = this.formActas.controls['inputLider'].value;

    if(nombre !== '' && responsableId !== '' && !this.nombreExiste()){
      return '';
    }
    return 'w3-disabled';
  }
  /* actas eliminar */
  public async eliminarActa(acta){
    var text = '';
    if(acta.actividades.length !== 0){
      text = this.translate.instant('gestion.formulacion.alta-actas.borrarAsoc');
    }
    const result = await messages.confirmationSave(
      this.translate.instant('gestion.formulacion.alta-actas.eliminarActa'),
      text,
      this.translate
    );
    if (result) {
      messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'));
      if(acta.actividades.length !== 0){
        for(const actividad of acta.actividades){
          this.eliminarActividadSinPreguntar(actividad);
        }
      }
      try{
        const res = await firstValueFrom(this.altaActasService.deleteActas(acta));
        this.actas = this.actas.filter(act => act.id !== acta.id);
        Swal.close();
        this.obtenerActasNuevamente(this.translate.instant('swal.swalElimino'));
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }
  }
  /* actividades agregar */
  public modalActividades(accion,actas){
    this.accionActi = accion
    if(accion == 'nuevo'){
      this.actaId = actas.id;
      this.titModal = this.translate.instant('gestion.formulacion.alta-actas.titModalAct');
    }else{
      this.titModal = this.translate.instant('gestion.formulacion.alta-actas.titModalActEdit');
      this.edicionActividad = actas;
      this.formActividad.controls['inputNameAct'].setValue(this.edicionActividad.nombre);
      this.formActividad.controls['inputFechaIn'].setValue(moment(this.edicionActividad.fecha_inicio).format('YYYY-MM-DD'));
      this.formActividad.controls['inputFechaFn'].setValue(moment(this.edicionActividad.fecha_fin).format('YYYY-MM-DD'));
      this.formActividad.controls['inputLider'].setValue(this.edicionActividad.responsable.id);
    }
    this.modal2 = true;
  }
  public async guardarActividades(){
    let nombre = this.formActividad.controls['inputNameAct'].value;
    let fechaIni = this.formActividad.controls['inputFechaIn'].value;
    let fechaFin = this.formActividad.controls['inputFechaFn'].value;
    let responsableId = this.formActividad.controls['inputLider'].value;
    var idAux = this.accionActi === 'nuevo' ? this.actaId : this.edicionActividad.id
    var actividad = {
      nombre: nombre,
      fechaIni: fechaIni,
      fechaFin: fechaFin,
      responsableId: responsableId,
      id: idAux,
      dateIni: this.formActividad.controls['inputFechaIn'].value,
      dateFin: this.formActividad.controls['inputFechaFn'].value,
    };

    if(this.accionActi === 'editar'){
      var text = '';
      if(this.edicionActividad.history.length !== 0 && this.comprobacionCambioFecha() ){
        text = this.translate.instant('gestion.formulacion.alta-planes.borrarAvance');
      }
    }

    try{       
      if(this.accionActi == 'nuevo'){
        messages.messageSaving(this.translate.instant('swal.agregandoInfo'),this.translate.instant('swal.espere'));
        const res = await firstValueFrom(this.altaActasService.postActividades(actividad));
        const responsable = this.responsables.find(r => Number(r.id) === Number(actividad.responsableId));
        const acti = {
          ...res,
          nombre: res.name,
          fecha_inicio: moment(res.initial_date.split('T')[0]),
          fecha_fin: moment(res.end_date.split('T')[0]),
          projectId: res.id,
          responsable: {position: responsable.nombre, id: responsable.id},
          id: res.id,
          history: [],
          adicionales: []
        };
        if(this.adicionales.length !== 0){
          var act = res.id
          var adAltas = 0;
          for(const ad of this.adicionales){
            var adicional = {
              activityId: act,
              name: ad.name,
              type: ad.type,
            }
            const res3 = await firstValueFrom(this.altaActasService.postAdicionales(adicional));
            acti.adicionales.push(res3);
            adAltas++;
            if(adAltas === this.adicionales.length){
              this.obtenerActividadesNuevamente(this.translate.instant('swal.swalGuardo'));
            }
          }
          const actaAdd = this.actas.find(a => Number(a.id) === Number(actividad.id));
          actaAdd.actividades.push(acti);
          this.obtenerfechasActas();
          if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length !== 0 ){
            this.adicionales = this.actas[0].actividades[0].adicionales;
          }else if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length === 0 ){
            this.adicionales = [];
          }
          this.dataTablaMostrar('cam');
          this.obtResponsableDinamico();
        }
      }else{
        messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
        this.guardarActividadesEdit(actividad)
      } 
      
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public puedeGuardarActividades(){
    let nombre = this.formActividad.controls['inputNameAct'].value;
    let fechaIni = this.formActividad.controls['inputFechaIn'].value;
    let fechaFin = this.formActividad.controls['inputFechaFn'].value;
    let responsableId = this.formActividad.controls['inputLider'].value;

    if(nombre !== '' && fechaIni !== '' && fechaFin !== '' && responsableId !== '' && this.formActividad.controls['inputFechaFn'].status === 'VALID'){
      return '';
    }
    return 'w3-disabled';
  }
  public async guardarActividadesEdit(actividad){
    try{
      if(this.edicionActividad.history.length !== 0 && this.comprobacionCambioFecha() ){
        for(const his of this.edicionActividad.history){
          const res = await firstValueFrom(this.altaActasService.deleteHistory(his)); 
        }
      }
      const res2 = await firstValueFrom(this.altaActasService.patchActividades(actividad));
      const responsable = this.responsables.find(r => Number(r.id) === Number(actividad.responsableId));
      this.edicionActividad.name = actividad.name;
      this.edicionActividad.fecha_fin = moment(actividad.fechaFin);
      this.edicionActividad.fecha_inicio = moment(actividad.fechaIni);
      this.edicionActividad.responsable = {position: responsable.nombre, id: responsable.id};
      this.obtenerActividadesNuevamente(this.translate.instant('swal.swalGuardo'));
    }catch(err){
      messages.errorMessageGraph(err);
    }      
  }
  public puedeGuardarActividadesEdit(){
    let nombre = this.formActividad.controls['inputNameAct'].value;
    let fechaIni = this.formActividad.controls['inputFechaIn'].value;
    let fechaFin = this.formActividad.controls['inputFechaFn'].value;
    let responsableId = this.formActividad.controls['inputLider'].value;

    if(nombre !== '' && fechaIni !== '' && fechaFin !== '' && responsableId !== '' && this.formActividad.controls['inputFechaFn'].status === 'VALID'){
      return '';
    }
    return 'w3-disabled';
  }
  /* Eliminación de actividades */
  public async eliminarActividad(actividad){
    const result = await messages.confirmationSave(
      this.translate.instant('gestion.formulacion.alta-actas.borrarAct'),
      this.translate.instant(''),
      this.translate
    );
    if (result) {
      try{
        await firstValueFrom(this.altaActasService.deleteActividades(actividad));
        
        for(const acta of this.actas){
          acta.actividades = acta.actividades.filter(a => Number(a.id) !== Number(actividad.id));
        }
        this.obtenerfechasActas();
        if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length !== 0 ){
          this.adicionales = this.actas[0].actividades[0].adicionales;
        }else if(this.actas.length !== 0 && this.actas[0].actividades.length !== 0 && this.actas[0].actividades[0].adicionales.length === 0 ){
          this.adicionales = [];
        }
        this.dataTablaMostrar('cam');
        this.obtResponsableDinamico();

        this.obtenerActividadesNuevamente(this.translate.instant('swal.swalElimino'));
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }
  }
  public async eliminarActividadSinPreguntar(actividad){
    try{
      const res = await firstValueFrom(this.altaActasService.deleteActividades(actividad)); 
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* adicionales agregar */
  public modalAdicional(){
    this.titModal = this.translate.instant('gestion.formulacion.alta-actas.titModalAdi');
    this.modal3 = true;
  }
  public async guardarAdi(){
    var name =  this.formAdicional.controls['inputName'].value;
    var type =  this.formAdicional.controls['inputType'].value;
    
    this.totalAct = this.actas.length;   
    messages.messageSaving(this.translate.instant('swal.agreAdi'),this.translate.instant('swal.espere'));
    for(const acta of this.actas){
      for(const act of acta.actividades){
        var adicional = {
          activityId: act.id,
          name: name,
          type: type,
        }
        try{
          const res = await firstValueFrom(this.altaActasService.postAdicionales(adicional));
          act.adicionales.push(res)
        }catch(err){
          messages.errorMessageGraph(err);
        }
      }
    }
    this.adicionales = this.actas[0].actividades[0].adicionales;
    Swal.close();
    this.obtenerActividadesNuevamente(this.translate.instant('swal.swalGuardo'));
  }
  public puedeGuardarAdi(){
    let nombre =  this.formAdicional.controls['inputName'].value;
    let tipo =  this.formAdicional.controls['inputType'].value;
    if(nombre != '' && tipo != '' && !this.nombreExisteAdi()){
      return '';
    }
    return 'w3-disabled';
  }
  /* edición adicional */
  public async edicionAdicional(actividad: any, idAdicional: any){
    var inputValue: any, introdujo: any, guardo = false;
    inputValue  = actividad.adicionales[idAdicional].amount;

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.formulacion.alta-actas.ingresaMonto'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('menu.acep'),
      cancelButtonText: this.translate.instant('menu.cancel'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return this.translate.instant('gestion.formulacion.alta-actas.datoInv');
        }
        guardo = true;
        return '';
      }
    });
    
    if(guardo){
      try{
        actividad.adicionales[idAdicional].amount = introdujo["value"];
        const res = await firstValueFrom(this.altaActasService.patchAdicionales(actividad.adicionales[idAdicional],actividad.id)); 
        this.obtenerActividadesNuevamente(this.translate.instant('swal.swalGuardo'));
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }else {
      messages.cancelMessage(this.translate.instant('swal.cancelado'));
    }
  }
  public async edicionAdicionalN(actividad: any, idAdicional: any){
    var inputValue: any, introdujo: any, guardo = false;
    inputValue  = this.obtComment(actividad.adicionales[idAdicional].comments);

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.formulacion.alta-actas.ingresaValor'),
      text: "",
      input: 'text',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('menu.acep'),
      cancelButtonText: this.translate.instant('menu.cancel'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return this.translate.instant('gestion.formulacion.alta-actas.datoInv');
        }
        guardo = true;
        return '';
      }
    });
    
    if(guardo){
      try{
        var existe = false;
        var per =  Number(this.aniosDisponibles.filter(an => an.check)[0].name);
        for(const comen of actividad.adicionales[idAdicional].comments){
          var percom = Number(moment(comen.created_at).format('YYYY'));
          if(per === percom){
            comen.comment = introdujo.value;
            existe = true;
            const res = await firstValueFrom(this.altaActasService.patchComment(comen, actividad.adicionales[idAdicional].id));
            messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
          }
        }
        if(!existe){
          var date = new Date('1-1-'+Number(this.aniosDisponibles.filter(an => an.check)[0].name));
          var aux = {
            comment: introdujo.value,
            created_at: date.toISOString(),
            id: 0,
          }
          const res2 = await firstValueFrom(this.altaActasService.postComment(aux, actividad.adicionales[idAdicional].id)); 
          aux.id = res2.id;
          actividad.adicionales[idAdicional].comments.push(aux);
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }else {
          messages.cancelMessage(this.translate.instant('swal.cancelado'))
        }
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }
  }
  /*  */
  private comprobacionCambioFecha(){
    let fecIn = moment(this.formActividad.controls['inputFechaIn'].value);
    let fecFn = moment(this.formActividad.controls['inputFechaFn'].value);
    let fecInAct = moment(this.edicionActividad.fecha_inicio);
    let fecFnAct = moment(this.edicionActividad.fecha_fin);
    if(!fecIn.isSame(fecInAct, 'day')){
      return true;
    }
    if(!fecFn.isSame(fecFnAct, 'day')){
      return true;
    }
    return false;
  }
  public clickFuera(event, modal){
  if (event.target === document.getElementById(modal)) {
    document.getElementById(modal).classList.add('moveShake');
    setTimeout(() => {
      document.getElementById(modal).classList.remove('moveShake');
    },600);
  }
  }
  /* Cerrar modales */
  public close_modal(){
    this.editarArch = false;
    this.modal1 = false;
    this.modal2 = false;
    this.modal3 = false;
    // document.getElementById(modal)!.style.display = 'none';
    this.formActas.reset();
    this.formActividad.reset();
    this.formAdicional.reset();
  }
  /* Exportación */
  public exportarExcel(){
    let headers = [];
    let proyectos = [];
    let actividades = [];
    if (this.mostabla) {
      let mess = [];
      for(const m of this.meses){
        mess.push(m.name);
      }
      let actAdic = [];
      if(this.actasMostrar[0].actividades[0].adicionales.length > 0){
        for(const aa of this.actasMostrar[0].actividades[0].adicionales){
          actAdic.push(aa.name);
        }
      }
      headers.push([
        this.translate.instant('gestion.formulacion.alta-actas.titTab1'),
        this.translate.instant('gestion.formulacion.alta-actas.titTab3'),
        this.translate.instant('gestion.formulacion.alta-actas.titTab4'),
        this.translate.instant('gestion.formulacion.alta-actas.titTab5'),
        this.translate.instant('gestion.formulacion.alta-actas.titTab6'),
        ...actAdic]
      );

      for(const acta of this.actasMostrar){
          let adP = [];
          let acts = [];        
          for (let l = 0; l < this.maxAdi.length; l++) {
            if (this.edicionPro(acta, l)) {
              adP.push(this.imprimirPro(acta, l));
            } else {
              adP.push('');
            } 
          } 

          proyectos.push([
            acta.nombre,
            acta.responsable.position,
            this.obtFecha(acta.fecha_ini),
            this.obtDias(acta.fecha_ini, acta.fecha_fin),
            this.obtFecha(acta.fecha_fin),
            ...adP
          ])
          let adAct = [];

          for(const acti of acta.actividades){
            let a = []
            let aux = 0;
            if(acti.adicionales.length !== 0){
              for(var j = 0; j < acti.adicionales.length; j++){
                a.push(acti.adicionales[j].type==='moneda'?this.formatearnormal(acti.adicionales[j].amount):'')
                aux++;
              }
            }
            adAct.push(a)
            acts.push([
              '   '.concat(acti.nombre),
              acti.responsable.position,
              this.obtFecha(acti.fecha_inicio),
              this.obtDias(acti.fecha_inicio, acti.fecha_fin),
              this.obtFecha(acti.fecha_fin),
              ...a
            ])
          }
          actividades.push(acts);

      }
      let filtros = []
      this.excelService.generateExcelActasFormulacion("Formulación: Alta actas", headers, proyectos, actividades,  filtros, "alta_actas");
    }
  }
  /** Formato de cantidades */
  public formatearnormal(num: any){
    if(num === null){
      return 0;
    }
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  public formatearConDecimales(num: any){
    num = '' + num.toFixed(2);
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    if (splitRight === '.00')
      return  splitLeft;

    return  splitLeft + splitRight;
  }
  /** Metodos de ordenamiento */
  private ordenamientoPer(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAdi(array: any){
    if(array && array.length!==0){
      array.sort(function (a: any, b: any) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      return array;
    }else{
      return [];
    }
  }
  private ordenamientoAlf(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.nombre.toLowerCase() > b.nombre.toLowerCase() ) {
        return 1;
      }
      if ( a.nombre.toLowerCase() < b.nombre.toLowerCase() ) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAlfInv(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.nombre.toLowerCase() < b.nombre.toLowerCase() ) {
        return 1;
      }
      if ( a.nombre.toLowerCase() > b.nombre.toLowerCase() ) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = formGroup.get('inputNameActa').value;
      if(!nombre) {return null;}
      nombre = nombre.trim().toLowerCase()
      const existe = this.actas.some( el => {
        const exName = el.nombre.trim().toLowerCase();
        if(this.accionActa === 'editar'){
          return ( exName === nombre && el.id !== this.edicionActa.id);
        }else{
          return exName === nombre;
        }          
      });
      if(existe) return {isValid:true};
      return null;
    };
  }
  public nombreExiste():  boolean  {    
    return  this.formActas.hasError('isValid');
  }
  private nombreDuplicidadAdi(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = formGroup.get('inputName').value;
      if(!nombre) {return null;}
      nombre = nombre.trim().toLowerCase()
      const existe = this.actas[0].actividades[0].adicionales.some( el => {
        const exName = el.name.trim().toLowerCase();
          return exName === nombre;
      });
      if (existe) return { isValid: true};      
      return null;
    };
  }
  public nombreExisteAdi():  boolean  {    
    return  this.formAdicional.hasError('isValid');
  }
  /* Edición y eliminación de adicionales */
  public async editarAdicional(adi: any){
    var guardo = false;
    var introdujo = await Swal.fire({
      title: this.translate.instant('gestion.formulacion.alta-planes.ingreseAdi'),
      text: "",
      input: 'text',
      inputValue: adi.name,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('menu.acep'),
      cancelButtonText: this.translate.instant('menu.cancel'),
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        value = value.trim().toLowerCase()
        const existe = this.actas[0].actividades[0].adicionales.some( el => {
          const exName = el.name.trim().toLowerCase();
            return (exName === value && el.id !== adi.id);
        });
        if (!value) {
          return this.translate.instant('gestion.formulacion.alta-planes.datoInv');
        }
        if (existe) {
          return this.translate.instant('gestion.formulacion.alta-planes.nombreExis');
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      var edit = 0;
      const name = adi.name;
      messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
      for(const acta of this.actas){
        for(const acti of acta.actividades){
          const adEdit = acti.adicionales.filter(ad => ad.name === name && ad.type === adi.type);
          if(adEdit.length !== 0){
            adEdit[0].name = introdujo.value;
            try{
              const res = await firstValueFrom(this.altaActasService.patchAdicionalesNombre(adEdit[0])); 
            }catch(err){
              messages.errorMessageGraph(err);
            }
          }
        }
      }
      Swal.close();
      this.obtenerActividadesNuevamente(this.translate.instant('swal.swalGuardo'));
    }
  }
  public async eliminarAdicional(adi: any){
    const guardo = await messages.confirmationSave(
      this.translate.instant('gestion.formulacion.alta-actas.eliminarAdi'),
      this.translate.instant('gestion.formulacion.alta-actas.infoContenida'),
      this.translate
    );

    if(guardo){
      const name = adi.name;
      messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'));
      for(const acta of this.actas){
        for(const acti of acta.actividades){
          const adEdit = acti.adicionales.filter(ad => ad.name === name && ad.type === adi.type);
          acti.adicionales = acti.adicionales.filter(ad => !(ad.name === name && ad.type === adi.type));
          if(adEdit.length !== 0){
            try{
              const res = await firstValueFrom(this.altaActasService.deleteAdicional(adEdit[0])); 
            }catch(err){
              messages.errorMessageGraph(err);  
            }
          }
        }
      }
      this.adicionales = this.actas[0].actividades[0].adicionales;
      Swal.close();
      this.obtenerActividadesNuevamente(this.translate.instant('swal.swalElimino'));
    }
  }

  private yearStart = new Date(new Date().getFullYear(), 0, 1);
  private yearDays  = 365;

  setYear(year: number): void {
    this.yearStart = new Date(year, 0, 1);
    const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    this.yearDays  = isLeap ? 366 : 365;
  }
  getBarLeft(fecha: moment.Moment | string): string {
    if (!fecha) return '0%';
    const start = moment.isMoment(fecha) ? fecha.toDate() : new Date(fecha);
    const days = (start.getTime() - this.yearStart.getTime()) / 86400000;
    return Math.max(0, (days / this.yearDays) * 100).toFixed(2) + '%';
  }
  getBarWidth(fechaIni: moment.Moment | string, fechaFin: moment.Moment | string): string {
    if (!fechaIni || !fechaFin) return '0%';
    const start = moment.isMoment(fechaIni) ? fechaIni.toDate() : new Date(fechaIni);
    const end   = moment.isMoment(fechaFin) ? fechaFin.toDate() : new Date(fechaFin);
    const days  = (end.getTime() - start.getTime()) / 86400000 + 1;
    return Math.max(0.5, (days / this.yearDays) * 100).toFixed(2) + '%';
  }
  getMesWidth(mes: any): string {
    return ((mes.value / this.yearDays) * 100).toFixed(3) + '%';
  }
  getMesesConDias(year: number) {
    return [
      { name: 'ene', value: 31 },
      { name: 'feb', value: new Date(year, 2, 0).getDate() }, // 28 o 29 según año bisiesto
      { name: 'mar', value: 31 },
      { name: 'abr', value: 30 },
      { name: 'may', value: 31 },
      { name: 'jun', value: 30 },
      { name: 'jul', value: 31 },
      { name: 'ago', value: 31 },
      { name: 'sep', value: 30 },
      { name: 'oct', value: 31 },
      { name: 'nov', value: 30 },
      { name: 'dic', value: 31 },
    ];
  }
}
